var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Cartillas (" + _vm._s(_vm.cartillas.length) + ")")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.imprimir }
              },
              [
                _c("i", { staticClass: "fa fa-print" }),
                _c("span", [_vm._v("Imprimir")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xs-12" }, [
          _c(
            "div",
            {
              staticClass: "table-responsive",
              staticStyle: { "max-height": "300px" }
            },
            [
              _c("table", [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("ID")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Fecha de venta")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Día de recaudación")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Número de documento")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Recaudador")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Cliente")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Observación")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Valor de pago")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Total")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Saldo")]),
                    _vm._v(" "),
                    _c("th", [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-success",
                            attrs: { type: "button" },
                            on: { click: _vm.agregar }
                          },
                          [_c("i", { staticClass: "fa fa-plus" })]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.cartillas, function(cartilla, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(index + 1) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.fecha) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.descripcion_dia_cobro) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.numero_documento) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.recaudador.nombre) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.nombre_cliente) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.observacion) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(cartilla.valor_pagos)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(cartilla.valor_total)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(cartilla.saldo_total)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td")
                      ])
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.cartillasAdicionales, function(cartilla, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.fecha) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.descripcion_dia_cobro) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.numero_documento) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.recaudador.nombre) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.nombre_cliente) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(cartilla.observacion) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(cartilla.valor_pagos)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(cartilla.valor_total)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.moneyFormat(cartilla.saldo_total)) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn-danger btn--text",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.quitarCartilla(cartilla)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-times" })]
                          )
                        ])
                      ])
                    }),
                    _vm._v(" "),
                    _vm.cartillas.length === 0 &&
                    _vm.cartillasAdicionales.length === 0
                      ? _c("tr", [
                          _c("td", { attrs: { colspan: "11" } }, [
                            _vm._v("No se ha encontrado recaudaciones")
                          ])
                        ])
                      : _c("tr", [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("td", [
                            _c("b", [
                              _vm._v(
                                "  " +
                                  _vm._s(
                                    _vm.moneyFormat(
                                      _vm.calcularTotalValorPago()
                                    )
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td"),
                          _vm._v(" "),
                          _c("td", [
                            _c("b", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.moneyFormat(_vm.calcularTotalSaldo())
                                  ) +
                                  " "
                              )
                            ])
                          ])
                        ])
                  ],
                  2
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          { staticClass: "btn-danger btn--text", on: { click: _vm.cerrar } },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cerrar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "cartillasAdicionales",
            scrollable: "",
            height: "auto",
            width: "80%",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [
          _c("cartillas-adicionales", {
            attrs: { recaudacionId: _vm.recaudacionId },
            on: {
              asignadas: _vm.cartillasAsignadas,
              cerrar: function($event) {
                return _vm.$modal.hide("cartillasAdicionales")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "7" } }, [
      _c("b", [_vm._v(" Totales ")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63294091", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63294091","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/CartillasRecaudacion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-63294091","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/CartillasRecaudacion.vue
// module chunks = 0